import * as React from 'react';

export const EntryPanelIcon: React.FC = () => (
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="18"
  height="18"
  fill="none"
  stroke="currentColor"
  strokeWidth="1.75"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  
  <path d="M5 7V3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5v-4" />

  
  <path d="M2 12h11" />
  <path d="M9 8l4 4-4 4" />
</svg>
);
